import React from 'react';
import HeroImage from '../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Cyprus',
        link: '/banking-license-cyprus',
    },
]

function BankingLicenseMauritius () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Mauritius
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish Domestic & Offshore Banks in a Tier-1 African IFC
                            </h3>
                            <p className='page-paragraph'>
                                <b>Mauritius</b> has developed into a <b>highly respected financial hub</b>, with its <b>Bank of Mauritius (BoM)</b> regulating and supervising both <b>domestic and offshore banks</b>. The jurisdiction is ideal for <b>institutions aiming to serve Africa, India, and Asia</b>, as well as <b>international high-net-worth clients</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Domestic Commercial Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Offshore Private Banking",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "Corporate Banking",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a Mauritius Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Mauritius for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Regulator",
                                    paragraph: "Supervised by the Bank of Mauritius, ensuring full compliance with international banking standards.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Credibility",
                                    paragraph: "Recognized as a highly reputable jurisdiction — stronger standing than Seychelles or St. Lucia in global finance.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Gateway Location",
                                    paragraph: "Strategically positioned for Africa–India–Asia trade and investment flows, ideal for cross-border banking.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Double Tax Treaties",
                                    paragraph: "Access to 40+ tax treaties offering reduced withholding taxes and investment protection for financial institutions.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Stable Economy",
                                    paragraph: "Mauritius offers political stability, strong legal infrastructure, and a mature financial services sector.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Banking Licenses
                        </h3>
                        <p className='page-subtitle'>1. Domestic Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Serve residents and local businesses in Mauritius.", icon: GoDotFill },
                                { title: "Full retail & commercial banking services:", paragraph: 'Deposits & savings accounts, Consumer & corporate lending, Credit/debit card issuance.Trade finance and treasury services', icon: GoDotFill },
                                { title: "Capital Requirement:", paragraph: 'USD 25M+', icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. International (Offshore) Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Serve non-resident individuals and corporations only.", icon: GoDotFill },
                                { paragraph: "Popular for private banking, wealth management, and corporate banking.", icon: GoDotFill },
                                { title: "Services include:",paragraph: 'Multi-currency private accounts, Custody and asset protection, Trade finance and cross-border lending, Investment banking services', icon: GoDotFill },
                                { title: "Capital Requirement: ", paragraph: 'USD 25M+.', icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Capital & Regulatory Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Minimum Paid-Up Capital",
                                    paragraph: "USD 25M required for banking operations",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity",
                                    paragraph: "Global Business Company (GBC) incorporation required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Experienced bankers or financial executives — fit & proper individuals",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Resident Presence",
                                    paragraph: "Physical office, resident directors, and compliance officer mandatory",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "AML/KYC Compliance",
                                    paragraph: "Strict compliance aligned with FATF standards",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Reporting",
                                    paragraph: "Ongoing audits and regulatory filings submitted to the Bank of Mauritius",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Mauritius Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Recognition",
                                    paragraph: "Respected in Africa, Asia, and globally for banking and financial services",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Efficiency",
                                    paragraph: "International banks benefit from treaty advantages and tax exemptions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Access to Correspondent Banks",
                                    paragraph: "Stronger banking network access compared to light offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Hub",
                                    paragraph: "Ideal gateway to Africa, India, and Asia markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Wealth Management Platform",
                                    paragraph: "Attractive for HNWIs, family offices, and corporate banking clients",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define the banking model — retail, offshore, or private.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity Incorporation",
                                    paragraph: "Set up a Global Business Company (GBC) in Mauritius.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Preparation",
                                    paragraph: "Prepare business plan, AML/KYC framework, and financial projections.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "BoM Review",
                                    paragraph: "Bank of Mauritius conducts due diligence and fit & proper checks.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & Licensing",
                                    paragraph: "Final approval typically granted within 12–18 months.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "12–18 months from pre-application to license approval.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 300,000+ covering legal, compliance, and advisory services.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "Minimum USD 25M fully paid-up capital required.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Include audits, regulator fees, and compliance staffing.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to establish a domestic or offshore bank in a Tier-1 jurisdiction?"
                        description=
                            "<b>Mauritius</b> offers <b>banking licenses</b> regulated by the <b>Bank of Mauritius</b>, trusted worldwide for <b>credibility</b> and <b>tax efficiency</b>."
                        buttonText="Book a Mauritius Banking License Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicenseMauritius;

const faqData = [
    {
        question: "What’s the capital requirement for a Mauritius bank?",
        content: [
            { type: "answer", text: "USD 25M minimum." },
        ],
    },
    {
        question: "Can international banks serve Mauritian residents?",
        content: [
            { type: "answer", text: "No — offshore banks may only serve non-residents." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "12–18 months." },
        ],
    },
    {
        question: "Why choose Mauritius over Seychelles or Mwali?",
        content: [
            { type: "answer", text: "Mauritius offers Tier-1 credibility, treaty benefits, and stronger regulator reputation." },
        ],
    },
    {
        question: "Can a Mauritius bank issue debit/credit cards?",
        content: [
            { type: "answer", text: "Yes — subject to BoM approval and Visa/Mastercard partnerships." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We established a private bank in Mauritius to target African and Asian HNWIs. Offshore Advisory guided us through the Bank of Mauritius approval process.",
        author: "Richard A.",
        role: "Private Banker",
    },
    {
        quote:
            "Mauritius banking licensing gave us Tier-1 credibility. Offshore Advisory provided end-to-end support.",
        author: "Maria L.",
        role: "Corporate Banker",
    },
];